/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { GeometryLabelDto } from './GeometryLabelDto';
import {
    GeometryLabelDtoFromJSON,
    GeometryLabelDtoFromJSONTyped,
    GeometryLabelDtoToJSON,
} from './GeometryLabelDto';
import type { CreateDefinitionDto } from './CreateDefinitionDto';
import {
    CreateDefinitionDtoFromJSON,
    CreateDefinitionDtoFromJSONTyped,
    CreateDefinitionDtoToJSON,
} from './CreateDefinitionDto';
import type { RtSystemQuantityScopeDto } from './RtSystemQuantityScopeDto';
import {
    RtSystemQuantityScopeDtoFromJSON,
    RtSystemQuantityScopeDtoFromJSONTyped,
    RtSystemQuantityScopeDtoToJSON,
} from './RtSystemQuantityScopeDto';

/**
 * 
 * @export
 * @interface CreateEvaluationQuantityUsageDto
 */
export interface CreateEvaluationQuantityUsageDto {
    /**
     * 
     * @type {boolean}
     * @memberof CreateEvaluationQuantityUsageDto
     */
    isUsageEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEvaluationQuantityUsageDto
     */
    useEvaluationGeometry?: boolean;
    /**
     * 
     * @type {Array<RtSystemQuantityScopeDto>}
     * @memberof CreateEvaluationQuantityUsageDto
     */
    medicalSystemScope?: Array<RtSystemQuantityScopeDto> | null;
    /**
     * 
     * @type {Array<RtSystemQuantityScopeDto>}
     * @memberof CreateEvaluationQuantityUsageDto
     */
    qaEquipmentScope?: Array<RtSystemQuantityScopeDto> | null;
    /**
     * 
     * @type {Array<GeometryLabelDto>}
     * @memberof CreateEvaluationQuantityUsageDto
     */
    evaluationGeometries?: Array<GeometryLabelDto> | null;
    /**
     * 
     * @type {Array<CreateDefinitionDto>}
     * @memberof CreateEvaluationQuantityUsageDto
     */
    definitions?: Array<CreateDefinitionDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEvaluationQuantityUsageDto
     */
    $type?: CreateEvaluationQuantityUsageDtoTypeEnum;
}


/**
 * @export
 */
export const CreateEvaluationQuantityUsageDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoCreateEvaluationQuantityUsageDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.CreateEvaluationQuantityUsageDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateEvaluationQuantityUsageDtoTypeEnum = typeof CreateEvaluationQuantityUsageDtoTypeEnum[keyof typeof CreateEvaluationQuantityUsageDtoTypeEnum];



/**
 * Check if a given object implements the CreateEvaluationQuantityUsageDto interface.
 */
export function instanceOfCreateEvaluationQuantityUsageDto(value?: unknown): value is CreateEvaluationQuantityUsageDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateEvaluationQuantityUsageDtoTypeEnum)[0];
}

export function CreateEvaluationQuantityUsageDtoFromJSON(json: any): CreateEvaluationQuantityUsageDto {
    return CreateEvaluationQuantityUsageDtoFromJSONTyped(json, false);
}

export function CreateEvaluationQuantityUsageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEvaluationQuantityUsageDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isUsageEnabled': json['isUsageEnabled'] == null ? undefined : json['isUsageEnabled'],
        'useEvaluationGeometry': json['useEvaluationGeometry'] == null ? undefined : json['useEvaluationGeometry'],
        'medicalSystemScope': json['medicalSystemScope'] == null ? undefined : ((json['medicalSystemScope'] as Array<any>).map(RtSystemQuantityScopeDtoFromJSON)),
        'qaEquipmentScope': json['qaEquipmentScope'] == null ? undefined : ((json['qaEquipmentScope'] as Array<any>).map(RtSystemQuantityScopeDtoFromJSON)),
        'evaluationGeometries': json['evaluationGeometries'] == null ? undefined : ((json['evaluationGeometries'] as Array<any>).map(GeometryLabelDtoFromJSON)),
        'definitions': json['definitions'] == null ? undefined : ((json['definitions'] as Array<any>).map(CreateDefinitionDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateEvaluationQuantityUsageDtoToJSON(value?: CreateEvaluationQuantityUsageDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'isUsageEnabled': value['isUsageEnabled'],
        'useEvaluationGeometry': value['useEvaluationGeometry'],
        'medicalSystemScope': value['medicalSystemScope'] == null ? undefined : ((value['medicalSystemScope'] as Array<any>).map(RtSystemQuantityScopeDtoToJSON)),
        'qaEquipmentScope': value['qaEquipmentScope'] == null ? undefined : ((value['qaEquipmentScope'] as Array<any>).map(RtSystemQuantityScopeDtoToJSON)),
        'evaluationGeometries': value['evaluationGeometries'] == null ? undefined : ((value['evaluationGeometries'] as Array<any>).map(GeometryLabelDtoToJSON)),
        'definitions': value['definitions'] == null ? undefined : ((value['definitions'] as Array<any>).map(CreateDefinitionDtoToJSON)),
        '$type': value['$type'],
    });
}

